import { useEffect } from "react";
import { gsap } from "gsap";

interface TranslateYAnimationProps {
    svgElement: SVGElement;
    translateAngle: number,
    animationSpeed: number;
  }

  const TranslateYAnimation: React.FC<TranslateYAnimationProps> = ({
    svgElement,
    translateAngle = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        translateY: translateAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, translateAngle, animationSpeed]);
  
    return null;
  };
   
export default TranslateYAnimation;
